export const NO_ISSUE = 0;
const DAMAGED_ITEM_SELF_SERVE = 1001;
const MISSING_ITEM_SELF_SERVE = 1003;
const SPOILED_ITEM_SELF_SERVE = 1004;
export const OTHER_ISSUE_SELF_SERVE = 1099;

export const itemIssues = {
  [DAMAGED_ITEM_SELF_SERVE]: {
    value: DAMAGED_ITEM_SELF_SERVE,
    optionText: 'Damaged item(s)  (physical damage to packaging)',
  },
  [MISSING_ITEM_SELF_SERVE]: {
    value: MISSING_ITEM_SELF_SERVE,
    optionText: 'Missing item(s)  (item on the order slip did not arrive)',
  },
  [SPOILED_ITEM_SELF_SERVE]: {
    value: SPOILED_ITEM_SELF_SERVE,
    optionText: 'Spoiled item(s)  (past its freshness)',
  },
  [OTHER_ISSUE_SELF_SERVE]: {
    value: OTHER_ISSUE_SELF_SERVE,
    optionText:
      'Other (e.g. temperature issue, missing delivery, broken icepack, etc.)',
  },
} as const;
const pageOptions = { itemIssues };

export const itemIssueOptions = pageOptions['itemIssues'];
export const itemDecisionOptions = {
  0: { value: 0, optionText: 'No, I’d like to talk to Customer Care' },
  1: {
    value: 1,
    optionText: 'Yes, add $&&& to my account to solve this issue',
  },
};
const itemDecisionOptionsOrder = Object.keys(itemDecisionOptions).reverse();

export enum INPUT_TYPES {
  SELECTOR = 'selector',
  TEXT_BOX = 'textBox',
  NONE = 'none',
}

// { pageId: pageOptions }
export const helpPageStructure = {
  1: {
    title: "We're here to help!",
    subtext: 'Did you have any of these issues with your delivery?',
    displayOptions: pageOptions['itemIssues'],
    selectedOptions: [],
    selectType: 'radio',
    inputType: INPUT_TYPES.SELECTOR,
  },
  2: {
    title: 'So sorry about that!',
    subtext: 'Please select the &&&.',
    displayOptions: [],
    selectedOptions: [],
    selectType: 'checkbox',
    inputType: INPUT_TYPES.SELECTOR,
  },
  3: {
    title: 'Were there any issues with your delivery experience?',
    subtext: 'Please select one below.',
    displayOptions: undefined,
    selectedOptions: [],
    selectType: 'radio',
    inputType: INPUT_TYPES.SELECTOR,
  },
  4: {
    title: 'Can we make this up to you?',
    subtext: `We’d love to make this right by adding $&&& to your Hungryroot account. \n If you’d like to connect with Customer Care, we’ll look into this further and follow up with you ASAP.`,
    displayOptions: itemDecisionOptions,
    selectedOptions: [],
    selectType: 'radio',
    inputType: INPUT_TYPES.SELECTOR,
    ordering: itemDecisionOptionsOrder,
  },
  5: {
    title: 'All set, &&&!',
    subtext:
      'Nice! Your $&&& will be automatically applied to your next delivery.',
    displayOptions: [],
    selectedOptions: [],
    selectType: 'checkbox',
    inputType: INPUT_TYPES.NONE,
  },
  6: {
    title: 'We want you to have the best experience possible.',
    subtext:
      'Click “next” to get in touch with our Customer Care team. If you’d like to include any other information, feel free to add it below.',
    displayOptions: [],
    selectedOptions: [],
    selectType: 'none',
    inputType: INPUT_TYPES.TEXT_BOX,
  },
  7: {
    title: 'We’ll send you an email soon!',
    subtext:
      'Our Customer Care team will get back to you via email ASAP. Thanks for your patience, &&&!',
    displayOptions: [],
    selectedOptions: [],
    selectType: 'none',
    inputType: INPUT_TYPES.NONE,
  },
  8: {
    title: 'Oh no! Something went wrong.',
    subtext:
      'Please reach out to support@hungryroot.com. We could not process your request.',
    displayOptions: [],
    selectedOptions: [],
    selectType: 'checkbox',
    inputType: INPUT_TYPES.NONE,
  },
} as const;
